<template>
  <div class="content">
    <div class="head_goback">
      <img class="scanarr" src="../assets/img/icon/left-arrow.png" @click="back" />
    </div>
    <div id="code">
      <div
        style="width:14rem;height:14rem; background-color: #429eff; margin: 15% auto 5%; text-align: center"
      ></div>
      <p class="tip" style="text-align: center">...载入中...</p>
    </div>
    <p>将二维码放入框内，即可自动扫描</p>
    <div style="text-align: center" class="sweep" @click="sweep">开始扫码</div>
    <div style="text-align: center" class="start" @click="back">识别失败，手动录入</div>
  </div>
</template>
<script type='text/ecmascript-6'>
export default {
  data() {
    return {
      scan: ""
    };
  },
  mounted() {
    const self = this;
    this.$nextTick(() => {
      if (window.plus) {
        self.plusReady();
      } else {
        document.addEventListener("plusready", self.plusReady, false);
      }
      document.addEventListener(
        "DOMContentLoaded",
        function() {
          self.domready = true;
          self.plusReady();
        },
        false
      );
    });
  },
  methods: {
    plusReady() {
      const self = this;
      // 获取窗口
      self.scan = new plus.barcode.Barcode("code");
      self.scan.onmarked = self.onmarked;
      self.scan.start();
    },
    sweep() {
      const self = this;
      self.scan.start();
    },
    onmarked(type, result) {
      let that = this;
      var text = "未知: ";

      switch (type) {
        case plus.barcode.QR:
          type = "QR";
          break;
        case plus.barcode.EAN13:
          type = "EAN13";
          break;
        case plus.barcode.EAN8:
          type = "EAN8";
          break;
        default:
          type = "其他" + type;
          break;
      }
      result = result.replace(/\n/g, "");
      let rsts = result.toLowerCase().split("/regist?code=");
      that.codeUrl = rsts.length == 2 ? rsts[1] : "";
      if (that.codeUrl != "") {
        that.scan.close();
        that.$router.push({ path: "/Regist", query: { code: that.codeUrl } });
      } else {
        plus.runtime.openURL(result);
      }
    },
    //   点击返回并关闭
    back() {
      const self = this;
      self.scan.close();
      this.$router.push({
        path: "/Regist"
      });
    }
  }
};
</script>
<style lang="less" scoped >
.content {
  background-color: #000;
  color: white;
  height: 100vh;
  .head_goback {
    background-color: #000;
    text-align: left;
    .scanarr {
      width: 25px;
      height: 25px;
      position: relative;
      top: 20px;
      left: 20px;
    }
  }
  p {
    font-size: 0.72rem;
  }
  .sweep {
    text-align: center;
    margin: 0.1rem auto;
    width: 13.8667rem;
    height: 1.7067rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1.024rem;
    font-size: 0.768rem;
    position: relative;
    z-index: 9999;
    color: white;
    background: #429eff;
    box-shadow: 0px 6px 9px 0px #429eff;
    margin-top: 2rem;
  }
  .start {
    text-align: center;
    margin: 0 auto;
    width: 13.8667rem;
    height: 1.7067rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1.024rem;
    font-size: 0.768rem;
    background: white;
    border: 2px solid #429eff;
    color: #429eff;
    margin-top: 0.64rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Scan.vue